import { _utilities } from '../utilities.js';
import { _wheelPlansPanel } from './wheelplans.js';
import { _data, TyreDetailLineModel, TyreCriteriaAttribute } from './data.tyre.js';
import { _tyresForm } from '../i247.VehicleLookup.js';
import CarouselHelper from './CarouselHelper.js';
import Common from '../i247.Common.js';

class TyreDetails {
	// --------------------------------------------------
	// CONSTRUCTOR
	// --------------------------------------------------
	constructor() {
		this.tyreAlreadySelected = new Set();
		this.duplicateTyreSelections = new Set();
		this.tyreAttributes = [];
		this.plan = null;
		this.axle = '';
		this.tyreLoading = false;
	}
	// --------------------------------------------------
	// GETTER AND SETTER
	// --------------------------------------------------

	// --------------------------------------------------
	// 'PRIVATE' FUNCTIONS
	// --------------------------------------------------

	ShowTyreDetailSection(plan, sectionId, navigatingForward) {
		let _this = this;
		$('li[data-menuanchor="' + plan + 'Anchor' + '"]').show();
		_data.wheelsSelected = plan;
		this.plan = plan = { Name: 'ALLTYRES', Position: 'ALLTYRES' };

		_utilities.LoadHtmlTemplate('/Tyres/GetPartialView', {
			positionName: plan.Name,
			positionLabel: plan.Position,
			viewName: '~/Views/Tyres/Partials/_tyreDetails.cshtml'
		},
			// callback
			async function (template) {
				if (navigatingForward) {
					$('#' + sectionId).empty();
					$('#' + sectionId).append(template);

					// init tyre visual
					$(`#ALLTYRES_tyreVisual .tyre-wrap h1`).lettering();
					$(`#ALLTYRES_tyreVisual .tyre-wrap h1 span`).addClass('rubber');

					// hide the tyre carousel by default
					$('#ALLTYRES_DetailContainer1').find('.tyre-edit').addClass('d-lg-none');
					$(`#ALLTYRES_slideTyreDropDownRight`).css('display', 'none');

					// load tyre history
					_this.GetTyreHistory();
					_this.SetupDefaultButtons(template);

				} else {
					// hide the tyre carousel by default
					$('#ALLTYRES_DetailContainer1').find('.tyre-edit').addClass('d-lg-none');
					$('.nextButton').show();
                }
			});
		$('#' + sectionId).show();
		$('.nextButton').hide();
		_utilities.BuildMobileBreadcrumbNav();
	}
	SetCurrentConfigToHistoricalData(positionToLoad, axleToApply, complete) {
		let _this = this;
		let historyData = Object.values(_data.vehicle.tyreHistory).find(attr => attr.positionCode === positionToLoad);

		// match the wheel position code final char which indicates front or rear to the first char of the axle label F or R
		let applyToConfigs;
		if (axleToApply === 'SPARE') {
			applyToConfigs = _this.tyreAttributes.filter(attr => attr.name === axleToApply.toUpperCase());
		} else {
			applyToConfigs = _this.tyreAttributes.filter(attr => attr.name.substring(2, 3) === axleToApply.substring(0, 1).toUpperCase());
        }

		applyToConfigs.forEach(config => {
			Object.keys(config.configuration).forEach(function (currentItem) {
				let loadPosition = currentItem.toLowerCase();
				if (loadPosition === 'loadindex') loadPosition = 'loadIndex';
				if (loadPosition === 'diameter') loadPosition = 'rim';
				if (loadPosition === 'brand') loadPosition = 'brandName';

				if (historyData[loadPosition] !== undefined) {
					config.configuration[currentItem].value = historyData[loadPosition];
				}
			});
			config.configuration.complete = true;
			if (!complete) {
				_this.GoToTyreVisualIndex(config.configuration, 0);
            }
		});

		_this.tyreLoading = false;
	}

	GoToTyreVisualIndex(currentPositionConfiguration, index) {
		let currentPosition = 'ALLTYRES';

		// if we already have a value then it was loaded by tyre history/or edit - validate - show next button
		let widthDdl = $(`#${currentPosition}_Width`)[0];
		let ratiosDdl = $(`#${currentPosition}_Ratio`);
		let diametersDdl = $(`#${currentPosition}_Diameter`);
		let loadRatingsDdl = $(`#${currentPosition}_LoadRating`);
		let speedRatiosDdl = $(`#${currentPosition}_SpeedRating`);
		let constructionsDdl = $(`#${currentPosition}_Construction`);

		//TO DO - check data is valid still as historical tyre may no longer be available as current product - told to not worry for now.
		widthDdl.value = currentPositionConfiguration.width.value;
		ratiosDdl.data('kendoDropDownList').value(currentPositionConfiguration.profile.value);
		diametersDdl.data('kendoDropDownList').value(currentPositionConfiguration.diameter.value);
		loadRatingsDdl.data('kendoDropDownList').value(currentPositionConfiguration.loadindex.value);
		speedRatiosDdl.data('kendoDropDownList').value(currentPositionConfiguration.speed.value);
		constructionsDdl.data('kendoDropDownList').value(currentPositionConfiguration.construction.value);

		let $previous = $(`#ALLTYRES_slideTyreDropDownLeft`);
		let $next = $(`#ALLTYRES_slideTyreDropDownRight`);
		if (index > 0) {
			$next.css('display', 'block').addClass('rightmove');
		}

		if (index > 5) {
			$(`#ALLTYRES_carouselTyresDropDownLists`).find(`.carousel-item:nth-child(7)`).addClass('active');
			CarouselHelper.nextIndex = 5;
			$previous.css('display', 'block').addClass('leftmove');
			$next.css('display', 'none');
		} else {
			$(`#ALLTYRES_carouselTyresDropDownLists`).find(`.carousel-item:nth-child(${index + 1})`).addClass('active');
			CarouselHelper.nextIndex = index;
			let itemToSelect = Object.keys(currentPositionConfiguration).find(attr => currentPositionConfiguration[attr].position === index + 1);
			currentPositionConfiguration[itemToSelect].selected = true;

			if (index != 0) {
				$previous.css('display', 'block').addClass('leftmove');
				$next.css('display', 'block').addClass('rightmove');
			}
			this.SetTyreVisual(currentPositionConfiguration, index, currentPosition);
		}
	}

	GetTyreHistory() {
		let _this = this;
		let historyData = _data.vehicle.tyreHistory;
		let $historyDiv = $(`#ALLTYRES_DetailContainer1`).find('.tyre-history-data');
		$historyDiv.html('');

		let axlePlan = {
			FRONT: ['NSF', 'OSF'], REAR: ['NSR', 'NSR2', 'OSR2', 'OSR'], SPARE: ['SPARE']
		}

		if (historyData.length === 0) {
			Object.keys(axlePlan).forEach(item => {
				// for each axle plan - show some boxes
				let textExtra = !(item === 'SPARE') ? ' axle' : '';
				let textLabel = `<div class="axle-details" data-axle="${item}">Please click and enter your tyre details for the <span class="font-weight-bold ds-contents">${item}</span>${textExtra}</div>`;
				let historyContent = '';

				let wheelsActive = 0;
				Object.values(axlePlan[item]).forEach(wheel => {
					// check if wheel plan active
					let foundConfig = Object.values(_this.tyreAttributes).find(attr => attr.name === wheel);

					if (foundConfig && wheelsActive < 1) {
						wheelsActive += 1;
						historyContent += `<div id="editHistory" class="ml-5 edit-history w-25 btn btn-outline-info text-dark font-weight-bold" data-axle="${item}" data-position="">Enter Details</div>`;
					}
				});
				if (wheelsActive > 0) {
					let htmlBuilder = `<div class="col-12 card mt-2 p-2">${textLabel}${historyContent}</div><br/>`;
					$historyDiv.html($historyDiv.html() + htmlBuilder);
					$historyDiv.parent().removeClass('d-lg-none');
				}
			});
		} else {
			Object.keys(axlePlan).forEach(item => {
				// for each axle plan - show some boxes
				let textExtra = !(item === 'SPARE') ? ' axle' : '';
				let textLabel = `<div class="axle-details" data-axle="${item}">Please click and enter your tyre details for the <span class="font-weight-bold ds-contents">${item}</span>${textExtra}</div>`;
				let historyLabel = SITE_EXTENDED_WARNINGS
					? `<div class="tyre-history-text">Good news. We've found existing tyre history for the <span class="font-weight-bold ds-contents">${item}</span>${textExtra} - Before confirming, please check your tyres and ensure this is correct.  Any incorrect tyres selected could cause delays to your booking. </div>`
					: `<div class="tyre-history-text">Good news. We've found existing tyre history for the <span class="font-weight-bold ds-contents">${item}</span>${textExtra} - Would you like to use this tyre size?</div>`;
				let historyContent = '';

				let wheelsActive = 0;
				Object.values(axlePlan[item]).forEach(wheel => {
					// check if wheel plan active
					let foundConfig = Object.values(_this.tyreAttributes).find(attr => attr.name === wheel);

					// just show the first history row for axle as newest - history array is ordered so new are at top
					if (foundConfig && wheelsActive < 1) {
						wheelsActive += 1;

						// wheel is active - is there any history data
						let foundConfig = Object.values(historyData).find(attr => attr.positionCode === wheel);

						if (foundConfig === undefined) {
							// no history found - find for history on same axle - checking last char
							let frontRear = wheel.substring(2, 3);
							foundConfig = Object.values(historyData).find(attr => attr.positionCode.includes(frontRear));
						}

						if (foundConfig !== undefined) {
							textLabel = historyLabel;

							// found history data - show data and hide the tyre selector.
							$(`#ALLTYRES_DetailContainer1`).find('.tyre-edit').addClass('d-lg-none');

							let data = foundConfig;
							historyContent += `<table class="w-100" data-axle="${item}"><tr>
											<td>${data.positionCode}</td>
											<td>${data.width}</td>
											<td>${data.profile}</td>
											<td>${data.rim}</td>
											<td>${data.speed}</td>
											<td>${data.loadIndex}</td>
											<td>${data.construction}</td>
											<td class="text-right">
												<div class="load-history btn btn-success font-weight-bold m-1" data-axle="${item}" data-position="${data.positionCode}">Confirm</div>
												<div class="edit-history btn btn-outline-info text-dark font-weight-bold btn-amend m-1" data-axle="${item}" data-position="${data.positionCode}">Amend</div>
											</td>
										  <tr></table>`;

						} else {
							historyContent += `<div id="editHistory" class="edit-history w-25 btn btn-outline-info text-dark font-weight-bold" data-axle="${item}" data-position="">Enter Details</div>`;
						}

					}
				});

				if (wheelsActive > 0) {
					let htmlBuilder = `<div class="col-12 card mt-2 p-2">${textLabel}${historyContent}</div><br/>`;
					$historyDiv.html($historyDiv.html() + htmlBuilder);
					$historyDiv.parent().removeClass('d-lg-none');
                }
			});
		}
	}

	HideTyreDetailSection(position, sectionId) {
		$('li[data-menuanchor="' + position + 'Anchor' + '"]').hide();
		kendo.destroy('#' + sectionId);
		$('#' + sectionId).hide();
		_utilities.BuildMobileBreadcrumbNav();
	}
	ResetForwardPositionData(currentPositionConfiguration, source) {
		currentPositionConfiguration.complete = false;
		let currentAttributeSelected = Object.values(currentPositionConfiguration).find(attr => attr.name === source);
		Object.values(currentPositionConfiguration).forEach(attr => {
			if (attr.position > currentAttributeSelected.position) {
				attr.value = '';
			}
		});
		// update history row to not valid - yellow
		$('#ALLTYRES_DetailContainer1 table[data-axle="' + this.axle + '"]').find('td:lt(8)').removeClass('tyre-done-highlight').addClass('bg-highlight');
	}
	RefreshTyreConfigurationAttributes(currentPosition, source, args, isback) {
		let _this = this;
		let result = $.Deferred();
		let container = $(`#tyreSection_TYRES`);
		let ratiosDdl = $(container).find(`#ALLTYRES_Ratio`).data('kendoDropDownList');
		let diametersDdl = $(container).find(`#ALLTYRES_Diameter`).data('kendoDropDownList');
		let loadRatingsDdl = $(container).find(`#ALLTYRES_LoadRating`).data('kendoDropDownList');
		let speedRatiosDdl = $(container).find(`#ALLTYRES_SpeedRating`).data('kendoDropDownList');
		let constructionsDdl = $(container).find(`#ALLTYRES_Construction`).data('kendoDropDownList');

		// *** USED ONLY FOR THE DATA LOOKUP - Get current config into a NON ref array - reset any values greater than current position
		let currentPositionConfiguration = _this.tyreAttributes.find(attr => attr.name === currentPosition).configuration;
		let currentPositionConfigurationFilter = JSON.parse(JSON.stringify(currentPositionConfiguration));
		let currentAttributeSelected = Object.values(currentPositionConfiguration).find(attr => attr.name === source);

		if (currentAttributeSelected) {
			Object.values(currentPositionConfigurationFilter).forEach(attr => {
				if (attr.position > currentAttributeSelected.position) {
					attr.value = '';
				}
			});
		}

		let filterCriteria = {
			Width: currentPositionConfigurationFilter.width.value,
			Profile: currentPositionConfigurationFilter.profile.value,
			Rim: currentPositionConfigurationFilter.diameter.value,
			LoadIndex: currentPositionConfigurationFilter.loadindex.value,
			Speed: currentPositionConfigurationFilter.speed.value,
			Construction: currentPositionConfigurationFilter.construction.value
		};
		//***

		// Get data based on the filter above
		let tyreConfigurationAttributes = _this.GetTyreConfigurationAttributes(filterCriteria);
		$.when(tyreConfigurationAttributes).done(function (data) {
			if (!isback) {
				if (ratiosDdl && source === 'width' && currentAttributeSelected.position <= 2) {
					let newProfilesSource = new kendo.data.DataSource({
						data: data.profiles
					});
					ratiosDdl.setDataSource(newProfilesSource);
					ratiosDdl.value(currentPositionConfiguration.profile.value);
					if (ratiosDdl.value().length > 0 && currentAttributeSelected.position === 1 && !isback) {
						container.find('span[id$="slideTyreDropDownRight"]').addClass('rightmove');
						ratiosDdl.trigger('change', [{ clearforwarddata: 0 }]);
					}
				}

				if (diametersDdl && source === 'profile' && currentAttributeSelected.position <= 3) {
					let newRimsSource = new kendo.data.DataSource({
						data: data.rims
					});
					diametersDdl.setDataSource(newRimsSource);
					diametersDdl.value(currentPositionConfiguration.diameter.value);
					if (diametersDdl.value().length > 0 && currentAttributeSelected.position === 2 && !isback) {
						container.find('span[id$="slideTyreDropDownRight"]').addClass('rightmove');
						diametersDdl.trigger('change', [{ clearforwarddata: 0 }]);
					}
				}

				if (loadRatingsDdl && source === 'diameter' && currentAttributeSelected.position <= 4) {
					let newLoadIndexesSource = new kendo.data.DataSource({
						data: data.loadIndexes
					});
					loadRatingsDdl.setDataSource(newLoadIndexesSource);
					loadRatingsDdl.value(currentPositionConfiguration.loadindex.value);
					if (loadRatingsDdl.value().length > 0 && currentAttributeSelected.position === 3 && !isback) {
						container.find('span[id$="slideTyreDropDownRight"]').addClass('rightmove');
						loadRatingsDdl.trigger('change', [{ clearforwarddata: 0 }]);
					}
				}

				if (speedRatiosDdl && source === 'loadindex' && currentAttributeSelected.position <= 5) {
					let newSpeedsSource = new kendo.data.DataSource({
						data: data.speeds
					});
					speedRatiosDdl.setDataSource(newSpeedsSource);
					speedRatiosDdl.value(currentPositionConfiguration.speed.value);
					if (speedRatiosDdl.value().length > 0 && currentAttributeSelected.position === 4 && !isback) {
						container.find('span[id$="slideTyreDropDownRight"]').addClass('rightmove');
						speedRatiosDdl.trigger('change', [{ clearforwarddata: 0 }]);
					}
				}

				if (constructionsDdl && source === 'speed' && currentAttributeSelected.position <= 6) {
					let newConstructionsSource = new kendo.data.DataSource({
						data: data.constructions
					});
					constructionsDdl.setDataSource(newConstructionsSource);
					constructionsDdl.value(currentPositionConfiguration.construction.value);
					if (constructionsDdl.value().length > 0 && currentAttributeSelected.position === 5 && !isback) {
						container.find('span[id$="slideTyreDropDownRight"]').addClass('rightmove');
						constructionsDdl.trigger('change', [{ clearforwarddata: 0 }]);
					}
				}
			}
			result.resolve(data);
		});

		return result.promise();
	}
	GetTyreConfigurationAttributes(criteria) {
		let result = $.Deferred();

		$.ajax({
			url: '/tyres/gettyreconfigurationattributes',
			type: 'GET',
			cache: false,
			data: criteria,
			success: function (data) {
				result.resolve(data);
			},
			error: function (xhr, ajaxOptions, thrownError) {
			},
			complete: function () {
			}
		});

		return result.promise();
	}

	GetContainer(event) {
		if (event !== undefined && event.sender !== undefined) {
			return $(event.sender.element).parents('.detailcontainer');
		}
		else {
			return this.currentSection.dom;
		}
	}
	CheckIfSelectionCompleted(event) {
		let _this = this;
		$('.nextButton').hide();
		if (_this.ConfigurationIsValid(event)) {
			$('.nextButton').show();
			let $container = _this.GetContainer(event);
			if ($container) {
				$container.find('span[id$="slideTyreDropDownLeft"]').addClass('leftmove');
				$container.find('#tyreConfigurationInvalidWarning').hide();
			}
		}
	}
	ShowHideSelectedWheels(navigatingForward) {
		let _this = this;
		if (_wheelPlansPanel._wheelPlan) {
			let position = this.currentSection.name.toUpperCase();
			let sectionId = this.currentSection.dom.prop('id');
			let section = this.currentSection.dom;
			let plan = _wheelPlansPanel._wheelPlan[this.currentSection.name.toUpperCase()];
			_this.plan = plan;
			_this.ShowTyreDetailSection('ALLTYRES', sectionId, navigatingForward);;
		}
	};

	async GetWidthDataSource() {
		let criteria = {
			Width: 0,
			Profile: "",
			Rim: "",
			LoadIndex: "",
			Speed: "",
			Construction: "",
			IncludeDefaultOption: false
		};

		let tyreConfigurationAttributes = await this.GetTyreConfigurationAttributes(criteria);
		return tyreConfigurationAttributes.widths;
	}

	BindTyreDetails(htmlTemplate, currentPosition) {
		let _this = this;

		let container = $(`#tyreSection_TYRES`);
		let widthsDdl = $(container).find(`#ALLTYRES_Width`);
		let ratiosDdl = $(container).find(`#ALLTYRES_Ratio`);
		let diametersDdl = $(container).find(`#ALLTYRES_Diameter`);
		let loadRatingsDdl = $(container).find(`#ALLTYRES_LoadRating`);
		let speedRatiosDdl = $(container).find(`#ALLTYRES_SpeedRating`);
		let constructionsDdl = $(container).find(`#ALLTYRES_Construction`);

		// TODO as were calling this function for multiple tyres (now against the same slide) - each time called, kendo add spans to the dom - it doesn't clean them up though!
		// kendo nesting dom elements over n over
		// this really needs modifying so the kendo elements are created and then the data source is changed for different tyres.
		// for now the below :(
		if (widthsDdl.data("kendoAutoComplete")) {
			kendo.destroy($(`#ALLTYRES_carouselTyresDropDownLists`)[0]);

			// get the controls container, move control to parent of that, remove the controls initial container. ffs.
			let container = widthsDdl.parent();
			container.parent().append(widthsDdl);
			container.remove();

			container = ratiosDdl.parent();
			container.parent().append(ratiosDdl);
			container.remove();

			container = diametersDdl.parent();
			container.parent().append(diametersDdl);
			container.remove();

			container = loadRatingsDdl.parent();
			container.parent().append(loadRatingsDdl);
			container.remove();

			container = speedRatiosDdl.parent();
			container.parent().append(speedRatiosDdl);
			container.remove();

			container = constructionsDdl.parent();
			container.parent().append(constructionsDdl);
			container.remove();
		}

		$.when(_this.GetWidthDataSource()).done(function (data) {
			let currentConfiguration = _this.tyreAttributes.find(attr => attr.name === currentPosition).configuration;
			$(htmlTemplate).find('.tyreDetailWidth').kendoAutoComplete({
				dataSource: data,
				dataTextField: 'name',
				dataValueField: 'value',
				change: function (args) {
					$('.nextButton').hide();
					CarouselHelper.nextIndex = 1;
					var found = false;
					var value = this.value();
					var data = this.dataSource.view();
					for (var idx = 0, length = data.length; idx < length; idx++) {
						if (data[idx].value === value) {
							found = true;
							break;
						}
					}

					// Only allow values in the dataSource list
					if (!found) {
						this.value("");
						$(`#${currentPosition}_slideTyreDropDownRight`).css('display', 'none');
						currentConfiguration.width.value = '';
					} else {
						let $this = $(args.sender.element);
						$this.parents('.detailcontainer').find('.card-footer').html('<span class="width_label">225</span>/<span class="profile_label">55</span> R<span class="diameter_label">16</span> <span class="load_label">91</span><span class="speed_label">V</span> <span class="construction_label">RFLT</span>');
						let $container = $this.parents('.detailcontainer');
						let labelClass = '.' + $this.data('label');
						let $displaySpan = $container.find(labelClass);
						let currentValue = $this.val();

						// reset any items already selected
						Object.keys(currentConfiguration).forEach(prop => (currentConfiguration[prop].selected !== undefined) && (currentConfiguration[prop].selected = false));

						// set the current item selected, new value.
						currentConfiguration.width.selected = true;
						currentConfiguration.width.value = currentValue;

						if (currentValue !== undefined && currentValue !== '') {
							$displaySpan.text(currentValue);
							$displaySpan.addClass('font-weight-bold').addClass('text-info');

							//$(`#ALLTYRES_slideTyreDropDownRight`).css('display', 'block').addClass('rightmove');
							$(`#ALLTYRES_slideTyreDropDownRight`).trigger('click');
						}
					}

					// always reset forward positions by default
					// args passed to disable reset if user went back and forward without changing values.
					if (args[0] === undefined || args[0]['clearforwarddata'] === 1) {
						_this.ResetForwardPositionData(currentConfiguration, 'width');
					}

					_this.RefreshTyreConfigurationAttributes(currentPosition, 'speed', null, false);
					_this.RefreshTyreConfigurationAttributes(currentPosition, 'loadindex', null, false);
					_this.RefreshTyreConfigurationAttributes(currentPosition, 'diameter', null, false);
					_this.RefreshTyreConfigurationAttributes(currentPosition, 'profile', null, false);
					_this.RefreshTyreConfigurationAttributes(currentPosition, 'width', null, false);

					_this.SetTyreVisual(currentConfiguration, 0, currentPosition);
				},
				placeholder: 'Width'
			});
			_this.tyreLoading = false;
		});

		$(htmlTemplate).find('.tyreDetailRatio').kendoDropDownList({
			dataSource: [],
			dataTextField: 'name',
			dataValueField: 'value',
			change: async function (args) {
				$('.nextButton').hide();
				CarouselHelper.nextIndex = 2;
				let currentConfiguration = _this.tyreAttributes.find(attr => attr.name === currentPosition).configuration;
				Object.keys(currentConfiguration).forEach(prop => (currentConfiguration[prop].selected !== undefined) && (currentConfiguration[prop].selected = false));
				currentConfiguration.profile.selected = true;
				currentConfiguration.profile.value = args.sender.element[0].value;

				if (args[0] === undefined || args[0]['clearforwarddata'] === 1) {
					_this.ResetForwardPositionData(currentConfiguration, 'profile');
				}

				if (currentConfiguration.profile.value !== '') {
					//$(`#ALLTYRES_slideTyreDropDownRight`).css('display', 'block').addClass('rightmove');
					$(`#ALLTYRES_slideTyreDropDownRight`).trigger('click');
				} else {
					$(`#ALLTYRES_slideTyreDropDownRight`).css('display', 'none');
				}

				_this.RefreshTyreConfigurationAttributes(currentPosition, 'speed', null, false);
				_this.RefreshTyreConfigurationAttributes(currentPosition, 'loadindex', null, false);
				_this.RefreshTyreConfigurationAttributes(currentPosition, 'diameter', null, false);
				_this.RefreshTyreConfigurationAttributes(currentPosition, 'profile', null, false);

				_this.SetTyreVisual(currentConfiguration, 1, _this.plan.Position);
			},
			optionLabel: 'Profile'
		});

		$(htmlTemplate).find('.tyreDetailDiameter').kendoDropDownList({
			dataSource: [],
			dataTextField: 'name',
			dataValueField: 'value',
			change: async function (args) {
				$('.nextButton').hide();
				CarouselHelper.nextIndex = 3;
				let currentConfiguration = _this.tyreAttributes.find(attr => attr.name === currentPosition).configuration;
				Object.keys(currentConfiguration).forEach(prop => (currentConfiguration[prop].selected !== undefined) && (currentConfiguration[prop].selected = false));
				currentConfiguration.diameter.selected = true;
				currentConfiguration.diameter.value = args.sender.element[0].value;

				if (args[0] === undefined || args[0]['clearforwarddata'] === 1) {
					_this.ResetForwardPositionData(currentConfiguration, 'diameter');
				}

				if (currentConfiguration.diameter.value !== '') {
					//$(`#ALLTYRES_slideTyreDropDownRight`).css('display', 'block').addClass('rightmove');
					$(`#ALLTYRES_slideTyreDropDownRight`).trigger('click');
				} else {
					$(`#ALLTYRES_slideTyreDropDownRight`).css('display', 'none');
				}

				_this.RefreshTyreConfigurationAttributes(currentPosition, 'speed', null, false);
				_this.RefreshTyreConfigurationAttributes(currentPosition, 'loadindex', null, false);
				_this.RefreshTyreConfigurationAttributes(currentPosition, 'diameter', null, false);

				_this.SetTyreVisual(currentConfiguration, 2, _this.plan.Position);
			},
			optionLabel: 'Diameter'
		});

		$(htmlTemplate).find('.tyreDetailLoad').kendoDropDownList({
			dataSource: [],
			dataTextField: 'name',
			dataValueField: 'value',
			change: async function (args) {
				$('.nextButton').hide();
				CarouselHelper.nextIndex = 4;
				let currentConfiguration = _this.tyreAttributes.find(attr => attr.name === currentPosition).configuration;
				Object.keys(currentConfiguration).forEach(prop => (currentConfiguration[prop].selected !== undefined) && (currentConfiguration[prop].selected = false));
				currentConfiguration.loadindex.selected = true;
				currentConfiguration.loadindex.value = args.sender.element[0].value;

				if (args[0] === undefined || args[0]['clearforwarddata'] === 1) {
					_this.ResetForwardPositionData(currentConfiguration, 'loadindex');
				}

				if (currentConfiguration.loadindex.value !== '') {
					//$(`#ALLTYRES_slideTyreDropDownRight`).css('display', 'block').addClass('rightmove');
					$(`#ALLTYRES_slideTyreDropDownRight`).trigger('click');
				} else {
					$(`#ALLTYRES_slideTyreDropDownRight`).css('display', 'none');
				}

				_this.RefreshTyreConfigurationAttributes(currentPosition, 'speed', null, false);
				_this.RefreshTyreConfigurationAttributes(currentPosition, 'loadindex', null, false);

				_this.SetTyreVisual(currentConfiguration, 3, _this.plan.Position);
			},
			optionLabel: 'Load'
		});

		$(htmlTemplate).find('.tyreDetailSpeed').kendoDropDownList({
			dataSource: [],
			dataTextField: 'name',
			dataValueField: 'value',
			change: async function (args) {
				$('.nextButton').hide();
				CarouselHelper.nextIndex = 5;
				let currentConfiguration = _this.tyreAttributes.find(attr => attr.name === currentPosition).configuration;
				Object.keys(currentConfiguration).forEach(prop => (currentConfiguration[prop].selected !== undefined) && (currentConfiguration[prop].selected = false));
				currentConfiguration.speed.selected = true;
				currentConfiguration.speed.value = args.sender.element[0].value;

				if (args[0] === undefined || args[0]['clearforwarddata'] === 1) {
					_this.ResetForwardPositionData(currentConfiguration, 'speed');
				}

				if (currentConfiguration.speed.value !== '') {
					//$(`#ALLTYRES_slideTyreDropDownRight`).css('display', 'block').addClass('rightmove');
					$(`#ALLTYRES_slideTyreDropDownRight`).trigger('click');
				} else {
					$(`#ALLTYRES_slideTyreDropDownRight`).css('display', 'none');
				}

				_this.RefreshTyreConfigurationAttributes(currentPosition, 'speed', null, false);

				_this.SetTyreVisual(currentConfiguration, 4, _this.plan.Position);
			},
			optionLabel: 'Speed'
		});

		$(htmlTemplate).find('.tyreDetailConstruction').kendoDropDownList({
			dataSource: [],
			dataTextField: 'name',
			dataValueField: 'value',
			change: async function (args) {
				$('.nextButton').hide();
				CarouselHelper.nextIndex = 6;
				let value = args.sender.element[0].value;
				let currentConfiguration = _this.tyreAttributes.find(attr => attr.name === currentPosition).configuration;
				Object.keys(currentConfiguration).forEach(prop => (currentConfiguration[prop].selected !== undefined) && (currentConfiguration[prop].selected = false));
				currentConfiguration.construction.selected = true;
				currentConfiguration.construction.value = value;

				if (args[0] === undefined || args[0]['clearforwarddata'] === 1) {
					_this.ResetForwardPositionData(currentConfiguration, 'construction');
				}

				//We will have a value for diameter
				var allFieldsValid = currentConfiguration.profile.value != ""
					&& currentConfiguration.diameter.value != ""
					&& currentConfiguration.loadindex.value != ""
					&& currentConfiguration.speed.value != "";

				if (!allFieldsValid) {
					return;
				}

				if (value.length > 0) {
					$(`#ALLTYRES_DetailContainer1 .axle-details[data-axle*='${_this.axle}']`).addClass('d-none');

					// final section - set complete
					currentConfiguration.complete = true;
					$('#ALLTYRES_DetailContainer1').find('.tyre-edit').addClass('d-lg-none');

					let newDataRow = `<tr><td colspan="8" class="text-dark">You have updated your ${_this.axle} tyre information as follows:</td></tr><tr>
											<td class="tyre-done-highlight">${currentPosition}</td>
											<td class="tyre-done-highlight">${currentConfiguration.width.value}</td>
											<td class="tyre-done-highlight">${currentConfiguration.profile.value}</td>
											<td class="tyre-done-highlight">${currentConfiguration.diameter.value}</td>
											<td class="tyre-done-highlight">${currentConfiguration.speed.value}</td>
											<td class="tyre-done-highlight">${currentConfiguration.loadindex.value}</td>
											<td class="tyre-done-highlight">${currentConfiguration.construction.value}</td>
											<td class="text-right tyre-done-highlight">
												<div class="reject-tyre-data btn btn-outline-info text-dark font-weight-bold btn-amend" data-axle="${_this.axle}" data-position="${currentPosition}">Amend</div>
											</td>
										  <tr>`;

					let $editButton = $(`#ALLTYRES_DetailContainer1 .tyre-history-data table td .edit-history[data-axle*='${_this.axle}']`);
					if ($editButton.length > 0) {
						$editButton.closest('tr').find('td').each(function () { $(this).removeClass('bg-highlight').removeClass('tyre-done-highlight') });
						$editButton.closest('tr').find('td:last .btn').css('display', 'none');
						$editButton.closest('table').find('tr:last').after(newDataRow);
					} else {
						$editButton = $(`#ALLTYRES_DetailContainer1 .edit-history[data-axle='${_this.axle}']`);
						$editButton.before(`<table>${newDataRow}</table>`)
						$editButton.css('display', 'none');
					}

					$(`#ALLTYRES_DetailContainer1`).find('.reject-tyre-data').unbind('click').on('click', function (event) {
						let row = $(this).closest('tr');
						let btns = row.parent().find('.btn');
						if (btns.length > 1) {
							row.parent().find('.btn').each(function () { $(this).css('display', 'inline-block'); })
							row.prev('tr').remove();
							row.remove();
						} else {
							row = $(this).closest('table');
							row.parent().find('.edit-history').css('display', 'inline-block');
							row.remove();
                        }

						let anyAxleConfig;
						_this.axle = $(this).data('axle');

						$(`#ALLTYRES_DetailContainer1 .axle-details[data-axle*='${_this.axle}']`).removeClass('d-none');

						$('#ALLTYRES_slideTyreDropDownLeft, #ALLTYRES_slideTyreDropDownRight').css('display', 'none');
						if (_this.axle === 'SPARE') {
							anyAxleConfig = _this.tyreAttributes.filter(attr => attr.name === _this.axle);
						} else {
							anyAxleConfig = _this.tyreAttributes.filter(attr => attr.name.substring(2, 3) === _this.axle.substring(0, 1));
						}

						if (anyAxleConfig.length > 0) {
							Object.values(anyAxleConfig[0].configuration).forEach(attr => {
								if (attr.value) {
									attr.value = ''
								}
							});
							anyAxleConfig[0].configuration.complete = false;
						}
					});

					// apply this config to any other selected on the same axle.
					let axleConfigurations = _this.tyreAttributes.filter(attr => attr.name.substring(2, 3) === currentPosition.substring(2, 3) && attr.name !== currentPosition);
					axleConfigurations.forEach(tyre => {
						tyre.configuration = currentConfiguration;
						tyre.complete = true;
					});
                }

				$(`#ALLTYRES_slideTyreDropDownRight`).css('display', 'none');

				_this.SetTyreVisual(currentConfiguration, 5, _this.plan.Position);
				_this.CheckIfSelectionCompleted(args);
			},
			optionLabel: 'Construction'
		});

		$('span[id$="slideTyreDropDownRight"]').closest('div').unbind('click').on('click', async function (event) {
			let $this = $(event.target);
			let $container = $this.parents('.detailcontainer');
			let $carousel = $container.find('.carousel');
			let currentConfiguration = _this.tyreAttributes.find(attr => attr.name === currentPosition).configuration;
			let currentAttributeSelected = Object.values(currentConfiguration).find(attr => attr.selected === true);

			!currentAttributeSelected && (currentAttributeSelected = currentConfiguration.width);
			!currentAttributeSelected.selected && (currentAttributeSelected.selected = true)

			if (currentAttributeSelected.value === '') return false;

			CarouselHelper.ValidateElements($carousel, 'next');
			//$(`#ALLTYRES_slideTyreDropDownLeft`).css('display', 'block').addClass('leftmove');
			$(`#ALLTYRES_slideTyreDropDownRight`).css('display', 'none').removeClass('rightmove');

			await _this.RefreshTyreConfigurationAttributes(currentPosition, currentAttributeSelected.name, $this, false);

			$container.find('.carousel').carousel('next').carousel('pause');
		});

		$('span[id$="slideTyreDropDownLeft"]').unbind('click').on('click',
			async function (event) {
				let $this = $(event.target);
				let $container = $this.parents('.detailcontainer');
				let $carousel = $container.find('.carousel');
				let currentConfiguration = _this.tyreAttributes.find(attr => attr.name === currentPosition).configuration;

				CarouselHelper.ValidateElements($carousel, 'prev');
				CarouselHelper.nextIndex -= 1;

				$carousel.carousel('prev').carousel('pause');
				$(`#ALLTYRES_slideTyreDropDownRight`).css('display', 'block').addClass('rightmove');

				if (CarouselHelper.nextIndex === 0) {
					$this.css('display', 'none');
				} else {
					$this.css('display', 'block');
				}

				let indexOfAttributeBeingSlidTo = CarouselHelper.nextIndex;
				if (indexOfAttributeBeingSlidTo >= 0) {
					let attributeBeingSlidTo = Object.values(currentConfiguration).find(attr => attr.position === indexOfAttributeBeingSlidTo + 1);

					// set previous attribute as current one
					Object.keys(currentConfiguration).forEach(prop => (currentConfiguration[prop].selected !== undefined) && (currentConfiguration[prop].selected = false));
					if (attributeBeingSlidTo != null) {
						attributeBeingSlidTo.selected = true;
						await _this.RefreshTyreConfigurationAttributes(currentPosition, attributeBeingSlidTo.name, $this, true);

						// make the text un-highlight as user goes back - uses user values if set
						_this.SetTyreVisual(currentConfiguration, indexOfAttributeBeingSlidTo, _this.plan.Position);
					}
				}
			}
		);

		if (_data.wheelsSelected.length > 0) {
			$(_data.wheelsSelected).each(function (index, tyreSelected) {
				if (tyreSelected.Position !== currentPosition) {
					$(htmlTemplate).find('.applyCurrentSelectionContainer .col').append(
						'<div class="form-check form-check-inline">' +
						'<input class="form-check-input" type="checkbox" id="' + tyreSelected.Position + '_duplicate")" value="' + tyreSelected.Position + '">' +
						'<label class="form-check-label" for="' + tyreSelected.Position + '_duplicate")">' + tyreSelected.Name + '</label>' +
						'</div>'
					);
					$('#' + tyreSelected.Position + '_duplicate').on('click', function (event) {
						// RemoveSection(tyreSelected.Position);
					});
				}
			});
		}
	}

	SetupDefaultButtons(template) {
		$('#leaseplanSizeHint').hide();

		let _this = this;
		_tyresForm.bindButtons();

		$(`#ALLTYRES_carouselTyresDropDownLists`).on('slid.bs.carousel', function (event) {
			let $currentContainer = $(this).parents('.detailcontainer');
			let labelName = $(event.relatedTarget).find('input').data('label');
			$currentContainer.find('.tyreLabelContainer span').removeClass('activelabel');
			$currentContainer.find('.' + labelName).addClass('activelabel');
		});

		$(`#ALLTYRES_DetailContainer1`).find('.edit-history').on('click', function (event) {
			let anyAxleConfig;

			if (!_this.tyreLoading) {
				_this.tyreLoading = true;
				_this.axle = $(this).data('axle');
				$('#ALLTYRES_slideTyreDropDownLeft, #ALLTYRES_slideTyreDropDownRight').css('display', 'none');
				if (_this.axle === 'SPARE') {
					anyAxleConfig = _this.tyreAttributes.filter(attr => attr.name === _this.axle);
				} else {
					anyAxleConfig = _this.tyreAttributes.filter(attr => attr.name.substring(2, 3) === _this.axle.substring(0, 1));
				}

				$(`#ALLTYRES_DetailContainer1`).find('#ALLTYRES_Width').val('');

				if (anyAxleConfig.length > 0) {
					CarouselHelper.nextIndex = 1;
					_this.BindTyreDetails(template, anyAxleConfig[0].name);
					($(this).data('position') === '') && _this.GoToTyreVisualIndex(anyAxleConfig[0].configuration, 0);
					$(`#ALLTYRES_DetailContainer1`).find('.tyre-edit').removeClass('d-lg-none');

					if (subdomain == 'leaseplan') {
						$('#leaseplanSizeHint').show();
					}
				}
				if ($(this).data('position') !== '') {
					$(this).closest('tr').find('td:lt(8)').removeClass('bg-highlight').addClass('tyre-done-highlight');
				}
			}
		});
		$(`#ALLTYRES_DetailContainer1`).find('.load-history').on('click', function (event) {
			let currentConfiguration = _this.tyreAttributes.find(attr => attr.name.substring(2, 3) === $(this).data('position').substring(2,3)).configuration;
			if (currentConfiguration && !_this.tyreLoading) {
				_this.tyreLoading = true;

				currentConfiguration.complete = true;
				$(this).closest('tr').find('td:lt(8)').removeClass('bg-highlight').addClass('tyre-done-highlight');
				$(`#ALLTYRES_DetailContainer1`).find('.tyre-edit').addClass('d-lg-none');
				$(`#ALLTYRES_slideTyreDropDownLeft`).css('display', 'none');
				let anyAxleConfig;
				_this.axle = $(this).data('axle');
				if (_this.axle === 'SPARE') {
					anyAxleConfig = _this.tyreAttributes.filter(attr => attr.name === _this.axle);
				} else {
					anyAxleConfig = _this.tyreAttributes.filter(attr => attr.name.substring(2, 3) === _this.axle.substring(0, 1));
				}

				if (anyAxleConfig.length > 0) {
					CarouselHelper.nextIndex = 1;
					_this.BindTyreDetails(template, anyAxleConfig[0].name);
				}

				_this.SetCurrentConfigToHistoricalData($(this).data('position'), $(this).data('axle'), true);
				_this.CheckIfSelectionCompleted(this);

			}
		});
    }
	UpdateTyreAttributes(position) {
		if (!this.tyreAttributes.find(attr => attr.name === position)) {
			this.tyreAttributes.push({
				name: position,
				configuration: {
					width: new TyreCriteriaAttribute('width', '', 1),
					profile: new TyreCriteriaAttribute('profile', '', 2),
					diameter: new TyreCriteriaAttribute('diameter', '', 3),
					loadindex: new TyreCriteriaAttribute('loadindex', '', 4),
					speed: new TyreCriteriaAttribute('speed', '', 5),
					construction: new TyreCriteriaAttribute('construction', '', 6),
					brand: new TyreCriteriaAttribute('brand', '', 7),
					complete: false
				}
			});
		}
	}
	GetWheelPositionsForMultiSelect(currentPosition) {
		let positionArray = [];
		for (let property in _wheelPlansPanel._wheelPlan) {
			if (_wheelPlansPanel._wheelPlan[property].Selected === 1 && _wheelPlansPanel._wheelPlan[property].Position !== currentPosition) {
				positionArray.push({ positionMoniker: _wheelPlansPanel._wheelPlan[property].Position, positionName: _wheelPlansPanel._wheelPlan[property].Name.replace('Side ', '') });
			}
		}
		return positionArray;
	}
	GetTyreDetails(position) {
		let tyreDetails = $.grep(_data.vehicle.tyreDetailLines, function (item) {
			return item.wheelSelected === position;
		});
		return tyreDetails ? tyreDetails[0] : null;
	}
	GetTyreText(currentConfiguration, index, position) {
		// Default text: 255/55 R16 91V RFLT - work out what text and what defaults to show plus extra chars, spacing - also return index for which chars to color.
		let textIndex = 0;
		let tyreText = '';
		let $container = $(`#tyreSection_TYRES`);

		// each section of the tyre text and associated default value if not set by user
		let tyrekey = [{ key: 'width', df: '255' }, { key: 'profile', df: '55' }, { key: 'diameter', df: '16' }, { key: 'loadindex', df: '91' }, { key: 'speed', df: 'V' }, { key: 'construction', df: 'RFLT' }]
		for (let item in tyrekey) {
			let doCountChars = false;
			let key = tyrekey[item].key;
			let currentValue = currentConfiguration[key].value;
			let $displaySpan = $container.find(`.tyreLabelContainer .${key}_label`);

			if (currentValue === undefined || currentValue === '') {
				currentValue = tyrekey[item].df;
				$displaySpan.removeClass('font-weight-bold').removeClass('text-info');
			} else {
				// we only want to count the chars if they were set by user
				doCountChars = true;
				$displaySpan.addClass('font-weight-bold').addClass('text-info');
			}

			// update the text box summary
			$displaySpan.text(currentValue);

			switch (key) {
				case 'width':
					currentValue += "/";
					break;
				case 'profile':
					currentValue += " ";
					break;
				case 'diameter':
					currentValue = "R" + currentValue + " ";
					break;
				case 'speed':
					currentValue += " ";
					break;
			}

			if (doCountChars && item <= index) {
				textIndex += currentValue.length;
			}

			tyreText += currentValue.toString();
		}
		return [tyreText, textIndex];
	}

	SetTyreVisual(currentConfiguration, index, position) {
		// set the text, styling, transforms to the tyre visual
		let tyreTextResult;
		//let highlight = 'var(--customer-color)';
		let highlight = '#fff';
		let wrapDiv = `#ALLTYRES_tyreVisual .tyre-wrap`;
		let transformDiv = `#ALLTYRES_tyreVisual .tyre-transform`;

		// reset any roation on the tyre
		$(`${transformDiv}`).css('--rotate', '0deg');

		if (index === 5) {
			//construction
			// get the text and counter indicating how many chars to color.
			tyreTextResult = this.GetTyreText(currentConfiguration, index, position);
			$(`${wrapDiv} h1`).text(tyreTextResult[0]);

			if ($(`${wrapDiv} h1`).text().length > 18) {
				// plus 6 degrees = 1 char
				let rotation = currentConfiguration.construction.value.length * 6;
				$(`${transformDiv}`).css('--rotate', `-${rotation}deg`);
			}

			$(`${wrapDiv} h1`).lettering();
			$(`${wrapDiv}`).each(function () { $(this).find('h1 span').slice(0, tyreTextResult[1]).css('color', highlight) });
		} else {
			// width,profile,diameter,loadindex,speed
			// get the text and counter indicating how many chars to color.
			tyreTextResult = this.GetTyreText(currentConfiguration, index, position);
			$(`${wrapDiv} h1`).text(tyreTextResult[0]);
			$(`${wrapDiv} h1`).lettering();

			if (tyreTextResult[1] > 0) {
				$(`${wrapDiv}`).each(function () { $(this).find('h1 span').slice(0, tyreTextResult[1]).css('color', highlight) });
			} else {
				$(`${wrapDiv} h1 span`).addClass('rubber');
			}
        }
	}

	// --------------------------------------------------
	// PUBLIC FUNCTIONS
	// --------------------------------------------------

	Initialise(sectionName, sectionDom, disableSection, enableSection, navigatingForward) {
		CarouselHelper.nextIndex = 0;
		this.currentSection = {
			name: sectionName,
			dom: sectionDom
		};

		let changeOccured = false;
		if (navigatingForward) {
			// init all selected tyre on wheel plan if not already init
			Object.values(_wheelPlansPanel._wheelPlan).filter(attr => attr.Selected).forEach(wheel => {
				let foundConfig = this.tyreAttributes.find(attr => attr.name === wheel.Position);
				if (!foundConfig) {
					this.UpdateTyreAttributes(wheel.Position);
					changeOccured = true;
				}
			})

			// remove any configs not on wheel plan
			for (var i = 0; i < this.tyreAttributes.length; i++) {
				let foundConfig = _wheelPlansPanel._wheelPlan[this.tyreAttributes[i].name];
				if (foundConfig.Selected === 0) {
					this.tyreAttributes.splice(i, 1);
					changeOccured = true;
				}
			}
		}
		// user went back but didn't change anything
		if (changeOccured === false) {
			navigatingForward = false;
        }

		this.ShowHideSelectedWheels(navigatingForward);

	};
	ConfigurationIsValid() {
		let _this = this;
		let isValid = _this.tyreAttributes.filter(attr => attr.configuration.complete === true).length === _this.tyreAttributes.length;
		return isValid;
	};
	Save() {
		let currentConfigurations = this.tyreAttributes.filter(attr => attr.configuration.complete === true);
		let tyreLines = [];

		currentConfigurations.forEach(tyre => {
			let tyreDetailLineModel = new TyreDetailLineModel();
			let selectedWheelPosition = tyre.name;
			let currentConfiguration = tyre.configuration;
			let editTyreDetailLineModel = Object.values(_data.vehicle.tyreDetailLines).find(attr => attr.wheelSelected === selectedWheelPosition);

			tyreDetailLineModel.wheelSelected = selectedWheelPosition;
			tyreDetailLineModel.title = tyre.name;
			tyreDetailLineModel.width = currentConfiguration.width.value;
			tyreDetailLineModel.ratio = currentConfiguration.profile.value
			tyreDetailLineModel.diameter = currentConfiguration.diameter.value
			tyreDetailLineModel.rating = currentConfiguration.speed.value
			tyreDetailLineModel.load = currentConfiguration.loadindex.value
			tyreDetailLineModel.construction = currentConfiguration.construction.value
			tyreDetailLineModel.brand = currentConfiguration.brand.value;
			tyreLines.push(tyreDetailLineModel);
		});

		_data.vehicle.tyreDetailLines = tyreLines;
	};
	GetValidator(position) {
		const $panel = this.currentSection.dom;
		return $panel.kendoValidator({
			rules: {
				//damageIssueField: function (input) {
				//	return true;
				//}
			},
			messages: {
				damageIssueField: 'Damage/Issue field is mandatory'
			}
		}).data('kendoValidator');
	};
}

export let _tyreConfigurationPanel = new TyreDetails();
